module.exports = __webpack_public_path__ + "img/diverse-workforces-mobile@2x.aa569fff.webp";